import { render } from "./AccountIndex.vue?vue&type=template&id=0b5abbcc"
import script from "./AccountIndex.vue?vue&type=script&lang=js"
export * from "./AccountIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__